import React, { useState, useEffect, useMemo, Fragment } from "react";
import styled, { css } from "styled-components";

// components
import Text from "components/ui/Text";
import TextField from "components/ui/TextField";
import Button from "components/entrance/Button";
import EntranceTemplate from "components/entrance/entrance-template";

const SigninTemplate = ({
  title,
  buttonOnClick,
  infoTitle = false,
  infoText = false,
  inputValue,
  inputValueChange,
  onClickBack,
  onClickFindPassword,
}) => {
  const [focused, setFocused] = useState([true, false]);
  const onFocus = (i) => {
    setFocused((previousValue) =>
      previousValue.map((v, idx) => (i === idx ? true : false)),
    );
  };
  const onBlur = (i) => {
    setTimeout(() => {
      setFocused((previousValue) =>
        previousValue.map((v, idx) => (i === idx ? false : v)),
      );
    }, 100);
  };

  useEffect(() => {
    return () => {
      setFocused([false, false]);
    };
  }, []);

  const handleClickFooter = (i) => {
    if (i === 0) {
      setFocused([false, true]);
    }
    if (i === 1) {
      setFocused([false, false]);
      buttonOnClick();
    }
  };

  const inputValidation = useMemo(() => {
    const { phoneNumber, passCode } = inputValue;
    return [phoneNumber.length < 12, passCode.length < 8];
  }, [inputValue]);

  const TopContent = useMemo(() => {
    return (
      <>
        <WrapperInput>
          <TextField
            type="tel"
            maxLength="13"
            label="아이디"
            placeholder="휴대폰 번호를 입력해주세요"
            value={inputValue.phoneNumber}
            onChange={(e) => {
              if (e.target.value.length === 13) {
                setFocused([false, true]);
              }
              inputValueChange(e, "phoneNumber");
            }}
            autoFocus={focused[0]}
            focused={focused[0]}
            onFocus={() => onFocus(0)}
            onBlur={() => onBlur(0)}
            css={css`
              margin-bottom: 16px;
            `}
          />
          <TextField
            pattern={false}
            type="password"
            maxLength="100"
            label="비밀번호"
            placeholder="비밀번호를 입력해주세요"
            value={inputValue.passCode}
            onChange={(e) => inputValueChange(e, "passCode")}
            autoFocus={focused[1]}
            focused={focused[1]}
            onFocus={() => onFocus(1)}
            onBlur={() => onBlur(1)}
            validation={
              !inputValue.isLogin && {
                color: "danger",
                text: "휴대폰번호와 비밀번호를 확인해주세요",
              }
            }
          />
        </WrapperInput>
        <WrapperText>
          <Text
            color="gray40"
            fontSize="14px"
            lineHeight="20px"
            onClick={onClickFindPassword}
          >
            비밀번호 찾기
          </Text>
        </WrapperText>
      </>
    );
  }, [focused, inputValue]);

  const BtmContent = useMemo(() => {
    return (
      <>
        {infoText && (
          <>
            <Text
              display="block"
              color="primary50"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              css={css`
                margin-bottom: 4px;
              `}
            >
              {infoTitle}
            </Text>
            <Text color="gray80" fontSize="14px">
              {infoText}
            </Text>
          </>
        )}
        {focused.filter((v) => v).length === 0 && (
          <Button
            color={
              !inputValidation[0] && !inputValidation[1] ? "white" : "disable"
            }
            background={
              !inputValidation[0] && !inputValidation[1]
                ? "primary100"
                : "gray5"
            }
            onClick={
              !inputValidation[0] && !inputValidation[1]
                ? buttonOnClick
                : () => {}
            }
          >
            로그인
          </Button>
        )}
        {focused.map((v, i) => {
          if (!v) return <Fragment key={i}></Fragment>;
          if (
            (i === 0 && !inputValidation[0]) ||
            (i === 1 && !inputValidation[0] && !inputValidation[1])
          ) {
            return (
              <div
                key={i}
                className="footer"
                onClick={() => handleClickFooter(i)}
              >
                <Text color="white" fontSize="18px" lineHeight="24px">
                  {i === 0 ? "다음" : "로그인"}
                </Text>
              </div>
            );
          }
          return (
            <div key={i} className="footer footer-disable">
              <Text
                fontSize="18px"
                lineHeight="24px"
                css={css`
                  color: #8d9cb0;
                `}
              >
                {i === 0 ? "다음" : "로그인"}
              </Text>
            </div>
          );
        })}
      </>
    );
  }, [focused, inputValue]);

  return (
    <EntranceTemplate
      title={title}
      topContent={TopContent}
      btmContent={BtmContent}
      onClickBack={onClickBack}
    />
  );
};

const WrapperInput = styled.div`
  margin-top: 32px;
`;
const WrapperText = styled.div`
  text-align: center;
  margin-top: 32px;
`;

export default SigninTemplate;
